import { SUBSCRIPTION_ACTION_TYPES } from "../actionTypes";

const initialState = {
  error: "",
  products_loading: false,
  products_error: false,
  products_success: false,
  products: [
    {
      packageName: "Bundle 1",
      productName: "Testing Product",
      price: 80
    },
    {
      packageName: "Bundle 2",
      productName: "Testing Product",
      price: 90
    },
    {
      packageName: "Bundle 3",
      productName: "Testing Product",
      price: 100
    }
  ],
  selected_product: {}
};

const ProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_ACTION_TYPES.PRODUCTS.RESET:
      return {
        products_loading: false,
        products_error: false,
        products_success: false,
        error: ""
      };
    case SUBSCRIPTION_ACTION_TYPES.PRODUCTS.GET_LOADING:
      return {
        ...state,
        products_loading: true,
        products_error: false,
        products_success: false
      };
    case SUBSCRIPTION_ACTION_TYPES.PRODUCTS.GET_SUCCESS:
      return {
        ...state,
        products: action.payload
      };
    case SUBSCRIPTION_ACTION_TYPES.PRODUCTS.SET_SELECTED_PRODUCT:
      return {
        ...state,
        selected_product: action.payload
      };
    case SUBSCRIPTION_ACTION_TYPES.PRODUCTS.GET_ERROR:
      return {
        ...state,
        products_loading: false,
        products_error: true,
        products_success: false,
        error: action.error.message
      };
    default:
      return state;
  }
};

export default ProductsReducer;
